import { render } from "./ProjectList.vue?vue&type=template&id=7951ece3"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/h5/luqiao/project/project/ProjectList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7951ece3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7951ece3', __exports__)) {
    api.reload('7951ece3', __exports__)
  }
  
  module.hot.accept("./ProjectList.vue?vue&type=template&id=7951ece3", () => {
    api.rerender('7951ece3', render)
  })

}


export default __exports__